import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { AdminAuthProvider } from "./context/AdminAuthContext";
import { GameCatalogProvider } from "./hooks/useGameCatalog";
import AdminGate from "./components/AdminGate";
import ModuleGate from "./components/ModuleGate";
import AdminLayout from "./layout/AdminLayout";
import Dashboard from "./pages/Dashboard";
import TournamentsList from "./TournamentsList";
import CreateTournament from "./CreateTournament";
import ManageTournament from "./pages/ManageTournament";
import AdminSignup from "./pages/AdminSignup";
import Users from "./pages/Users";
import Leads from "./pages/Leads";
import KycApprovals from "./pages/KycApprovals";
import Communities from "./pages/Communities";
import Creators from "./pages/Creators";
import Wallet from "./pages/Wallet";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Login from "./pages/Login";
import AccessDenied from "./pages/AccessDenied";

const App = () => {
  return (
    <AdminAuthProvider>
      <GameCatalogProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<AdminSignup />} />
            <Route path="/access-denied" element={<AccessDenied />} />
            <Route element={<AdminGate />}>
              <Route element={<AdminLayout />}>
                <Route
                  index
                  element={
                    <ModuleGate moduleId="dashboard">
                      <Dashboard />
                    </ModuleGate>
                  }
                />
                <Route
                  path="/tournaments"
                  element={
                    <ModuleGate moduleId="tournaments">
                      <TournamentsList />
                    </ModuleGate>
                  }
                />
                <Route
                  path="/tournaments/new"
                  element={
                    <ModuleGate moduleId="tournaments">
                      <CreateTournament />
                    </ModuleGate>
                  }
                />
                <Route
                  path="/tournaments/manage/:id"
                  element={
                    <ModuleGate moduleId="tournaments">
                      <ManageTournament />
                    </ModuleGate>
                  }
                />
                <Route
                  path="/users"
                  element={
                    <ModuleGate moduleId="users">
                      <Users />
                    </ModuleGate>
                  }
                />
                <Route
                  path="/leads"
                  element={
                    <ModuleGate moduleId="leads">
                      <Leads />
                    </ModuleGate>
                  }
                />
                <Route
                  path="/kyc-approvals"
                  element={
                    <ModuleGate moduleId="kyc">
                      <KycApprovals />
                    </ModuleGate>
                  }
                />
                <Route
                  path="/communities"
                  element={
                    <ModuleGate moduleId="communities">
                      <Communities />
                    </ModuleGate>
                  }
                />
                <Route
                  path="/creators"
                  element={
                    <ModuleGate moduleId="creators">
                      <Creators />
                    </ModuleGate>
                  }
                />
                <Route
                  path="/wallet"
                  element={
                    <ModuleGate moduleId="wallet">
                      <Wallet />
                    </ModuleGate>
                  }
                />
                <Route
                  path="/reports"
                  element={
                    <ModuleGate moduleId="reports">
                      <Reports />
                    </ModuleGate>
                  }
                />
                <Route
                  path="/settings"
                  element={
                    <ModuleGate moduleId="settings">
                      <Settings />
                    </ModuleGate>
                  }
                />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </GameCatalogProvider>
    </AdminAuthProvider>
  );
};

export default App;
